module.exports = __webpack_public_path__ + "img/RAM.bdb6bdd6.png";